import { MetalsProjectFile } from "@prism/prism-shared";

export function metalsProjectFileTooLarge(
  file: MetalsProjectFile,
  maxMb = 2
): boolean {
  const maxBytes = maxMb * 1024 * 1024 // 5,242,880 bytes 
  return file.size > maxBytes;
}